import React from 'react';
import { EditIcon, XIcon, ChevronRightIcon } from 'lucide-react';
// iOS-style share icon component
function IOSShareIcon({
  className = 'w-6 h-6'
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-429">
      <path d="M8.59 13.51l6.83 3.98" data-id="element-430" />
      <path d="M15.41 6.51l-6.82 3.98" data-id="element-431" />
      <circle cx="18" cy="5" r="3" data-id="element-432" />
      <circle cx="6" cy="12" r="3" data-id="element-433" />
      <circle cx="18" cy="19" r="3" data-id="element-434" />
    </svg>;
}
export function SaveMethodsMenu({
  onSelectMethod,
  onCancel
}) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center animate-fadeIn" data-id="element-435">
      <div className="bg-white rounded-t-3xl w-full max-w-lg animate-slideUp" data-id="element-436">
        <div className="p-6 border-b border-gray-100" data-id="element-437">
          <div className="flex items-center justify-between" data-id="element-438">
            <h2 className="text-xl font-semibold text-gray-900" data-id="element-439">Add Event</h2>
            <button onClick={onCancel} className="p-2 -mr-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Close" data-id="element-440">
              <XIcon className="w-5 h-5 text-gray-400" data-id="element-441" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-3" data-id="element-442">
          {/* Share from Another App - Primary Option */}
          <button onClick={() => onSelectMethod('share')} className="w-full group" data-id="element-443">
            <div className="flex items-start p-5 bg-blue-50 hover:bg-blue-100 rounded-2xl transition-all duration-200 border-2 border-blue-100 hover:border-blue-200" data-id="element-444">
              <div className="flex-shrink-0 w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform" data-id="element-445">
                <IOSShareIcon className="w-6 h-6 text-white" data-id="element-446" />
              </div>
              <div className="ml-4 flex-1 text-left" data-id="element-447">
                <div className="flex items-center justify-between" data-id="element-448">
                  <h3 className="font-semibold text-gray-900 text-base" data-id="element-449">
                    Share from another app
                  </h3>
                  <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors" data-id="element-450" />
                </div>
                <p className="text-sm text-gray-600 mt-1 leading-relaxed" data-id="element-451">
                  Save events from Instagram, websites, and other social media
                </p>
              </div>
            </div>
          </button>

          {/* Enter Manually - Secondary Option */}
          <button onClick={() => onSelectMethod('manual')} className="w-full group" data-id="element-452">
            <div className="flex items-start p-5 bg-gray-50 hover:bg-gray-100 rounded-2xl transition-all duration-200 border-2 border-transparent hover:border-gray-200" data-id="element-453">
              <div className="flex-shrink-0 w-12 h-12 bg-gray-200 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform" data-id="element-454">
                <EditIcon className="w-6 h-6 text-gray-600" data-id="element-455" />
              </div>
              <div className="ml-4 flex-1 text-left" data-id="element-456">
                <div className="flex items-center justify-between" data-id="element-457">
                  <h3 className="font-semibold text-gray-900 text-base" data-id="element-458">
                    Enter manually
                  </h3>
                  <ChevronRightIcon className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" data-id="element-459" />
                </div>
                <p className="text-sm text-gray-600 mt-1 leading-relaxed" data-id="element-460">
                  Fill out event details yourself
                </p>
              </div>
            </div>
          </button>
        </div>

        {/* Safe area padding for iOS */}
        <div className="h-8" data-id="element-461"></div>
      </div>
    </div>;
}